import React from "react";
import { twMerge } from "tailwind-merge";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  shadow?: "none" | "little" | "lots";
}

const Card: React.FC<CardProps> = ({ children, className, style, shadow }) => {
  return (
    <div
      className={twMerge(
        "bg-[var(--card-bg-color)] text-[var(--card-text-color)]",
        "homepage-card-rounded",
        shadow === "little"
          ? "shadow-md hover:shadow-lg ease-in-out duration-300"
          : "",
        shadow === "lots"
          ? "shadow-xl hover:shadow-2xl ease-in-out duration-300"
          : "",
        className
      )}
      style={style}
      data-component-type="Card"
    >
      {children}
    </div>
  );
};

export default Card;
